export default __webpack_public_path__ + "static/media/bedroom5.227d2a5e.webp";